module.exports = __webpack_public_path__ + "media/images/icon/tick-10008012a3f788a5742f0b6e9e4c5d38.svg";